import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { id }) => state.setIn(['user', 'deliveryZoneId'], id);

export const setActiveDeliveryZone = createAction({
  action: ['setActiveDeliveryZone', 'id'],
  handler,
});
